export default class filter {


    constructor(tabName = null, applyData = null) {
        this.applyData = applyData;
    }


    getFirstFilter() {

        let secondary = [];
        if (this.applyData) {
            secondary = this.applyData.secondary;
            //去掉排序
            if (secondary && secondary.length > 0) {
                secondary = secondary.slice(0, secondary.length - 1);
            }
        }
        return secondary
    }


    getSecondFilter() {
        // debugger;
        if (this.applyData.data && this.applyData.data.filtered && this.applyData.data.filtered.length > 0) {
            let filtered = this.applyData.data.filtered;
            return filtered;
        }
    }

    removeLimit(obj) {
        let newArr = new Array();
        if (obj) {
            obj.items.map((item) => {
                if (item.text != "不限") {
                    newArr.push(item);
                }
                item.optionTitle = item.text;
            })
        }
        return newArr;
    }

    getFilter() {
        let filtered = this.getSecondFilter();
        if (filtered) {
            filtered = JSON.parse(JSON.stringify(filtered));
        } else {
            return []
        }
        let ret = [{
                'fieldTitle': '航空公司',
                "value": 4,
                "options": this.removeLimit(filtered[1])
            },
            {
                'fieldTitle': '起飞机场',
                "value": 5,
                "options": this.removeLimit(filtered[2])
            },
            {
                'fieldTitle': '降落机场',
                "value": 6,
                "options": this.removeLimit(filtered[3])
            },
            {
                'fieldTitle': '直飞/中转',
                "value": 7,
                "options": this.removeLimit(filtered[0])
            },
        ]
        return ret;
    }
}